const data = [{
        id: 1,
        emoji: '😃',
        name: 'Smiling Face With Open Mouth',
        description: 'Typical smiley face with open mouth and oval eyes. Is in a positive mood, shows its teeth and laughs cheerfully. Expresses enthusiasm: from a cheerful greeting to boundless joy.'
    },
    {
        id: 2,
        emoji: '😅',
        name: 'Smiling Face With Open Mouth & Cold Sweat',
        description: 'Sweaty smile. Relief that a tight situation went well or was coped with positively, e.g. an important appointment. A difficult event is imminent and you are already nervous.'
    },
    {
        id: 3,
        emoji: '😊',
        name: 'Smiling Face With Smiling Eyes',
        description: 'Is grinning shyly and embarrassed. The red cheeks are an expression of joy. Represents happiness, contentment, peace of mind and gratitude. Text-based variant: ^^.'
    },
    {
        id: 4,
        emoji: '😉',
        name: 'Winking Face',
        description: 'Smiley blinks mischievously with one eye. Expression of humor, has been pulling a practical joke, is flirting with you or has an ulterior motive. The wink weakens the message: do not take it seriously, regard it as humorous.'
    },
    {
        id: 5,
        emoji: '😌',
        name: 'Relieved Face',
        description: 'Everything went well! Relieved smiley face. Is happy that something unpleasant is over without having caused any harm. Relaxed, thankful and free of worries.'
    },
    {
        id: 6,
        emoji: '😋',
        name: 'Face Savouring Delicious Food',
        description: 'Bon appetit! Smiley is licking the corner of its mouth with its tongue. Is hungry, just cooked something very delicious or eaten a whole dish. Often interpreted as a grimace, with tongue outstretched, and used after a funny message or when fooling around.'
    },
    {
        id: 7,
        emoji: '😎',
        name: 'Face With Sunglasses',
        description: 'I\'m the king of the world! Mr. Cool Smiley with sunglasses. Is totally self-assured and relaxed. Everything is absolutely easy and cool. Also a symbol for sun, summer holidays, and holidays on the beach.'
    },
    {
        id: 8,
        emoji: '😊',
        name: 'Smiling Face With Smiling Eyes',
        description: 'Is grinning shyly and embarrassed. The red cheeks are an expression of joy. Represents happiness, contentment, peace of mind and gratitude. Text-based variant: ^^.'
    },
    {
        id: 9,
        emoji: '🥳',
        name: 'Face with party blower and party hat',
        description: 'That was a wild party or “Let\'s celebrate“. No matter what joyful event is in view, it will be celebrated appropriately. May also stand for the carnival season.'
    },
    {
        id: 10,
        emoji: '😴',
        name: 'Sleeping Face',
        description: 'Good night and sweet dreams! In comics or cartoons, zZz above the head stands for sleeping characters. The emoji is tired, wants to go to bed or is just about to fall asleep from boredom.'
    }
];

export default data;